// Copyright (c) 2017 Deere & Company

export const getDealerInvoiceClaimsSortOptions = () => [
    {
        displayName: 'DEALER_LOCATION',
        path: [
            'dealer',
            'account'
        ]
    },
    {
        displayName: 'CITY',
        path: [
            'dealer',
            'location',
            'city'
        ]
    },
    {
        displayName: 'REQUESTED',
        path: [
            'sortByDate()'
        ]
    },
    {
        displayName: 'PIN',
        path: [
            'claimsProcess',
            'pin'
        ]
    },
    {
        displayName: 'STATUS',
        path: [
            'massProcess',
            'status',
            'value'
        ]
    }
];

export const getDealerInvoiceClaimsFilterOptions = () => [
    [
        'massProcess',
        'invoiceRequestNumber'
    ],
    [
        'massProcess',
        'dealerInvoiceNumber'
    ],
    [
        'massProcess',
        'status',
        'value'
    ],
    [
        'claimsProcess',
        'claimNumber'
    ],
    [
        'claimsProcess',
        'referenceNumber1'
    ],
    [
        'claimsProcess',
        'referenceNumber2'
    ],
    [
        'claimsProcess',
        'pin'
    ],
    [
        'claimsProcess',
        'claimType',
        'value'
    ],
    [
        'claimsProcess',
        'subClaimType',
        'value'
    ],
    [
        'dealer',
        'account'
    ],
    [
        'dealer',
        'location',
        'city'
    ]
];



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/services/dealer-invoice-helper.js